import { defineComponent as _defineComponent } from 'vue'
import { availableLocales } from '@@/bits/locale'
import { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzIconButton, {
  OzIconButtonColorScheme,
  OzIconButtonSizePreset,
} from '@@/library/v4/components/OzIconButton.vue'
import type { OzMenuRowsRow } from '@@/library/v4/components/OzMenuRows.vue'
import OzMenuRows, { OzMenuRowsFocusStyle, OzMenuRowsSizePreset } from '@@/library/v4/components/OzMenuRows.vue'
import OzScreenSizeAwarePopoverModal from '@@/library/v4/components/OzScreenSizeAwarePopoverModal.vue'
import type { PopoverAnchor } from '@@/types'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocaleMenu',
  props: {
    windowHeight: null,
    boxClasses: { default: () => [] },
    currentLocale: { default: 'en' },
    anchor: { default: () => ({}) },
    width: { default: 304 },
    isPhone: { type: Boolean, default: true },
    preferredTrayStartHeight: { default: undefined },
    xBackButton: { type: Boolean, default: true },
    xCloseButton: { type: Boolean, default: false },
    xHeader: { type: Boolean, default: true }
  },
  emits: ["cancel", "anchor-update", "back", "close", "change"],
  setup(__props: any) {

const props = __props as { windowHeight: number, boxClasses: string[], currentLocale: string, anchor: Partial<PopoverAnchor>, width: number, isPhone: boolean, preferredTrayStartHeight: number, xBackButton: boolean, xCloseButton: boolean, xHeader: boolean }





const rowData = computed<OzMenuRowsRow[]>(() => {
  return availableLocales.map((locale) => {
    return {
      text: locale.name,
      rightIcon: props.currentLocale === locale.html ? 'checkmark_thicker' : '',
      rightIconHighlighted: true,
      role: 'menuitemradio',
      ariaChecked: String(props.currentLocale === locale.html),
      eventPayload: locale.html,
      ref: locale.html,
      testId: `${locale.standard}LanguageMenuRow`,
    }
  })
})

return { __sfc: true,props, rowData, OzBoxColors, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzMenuRows, OzMenuRowsFocusStyle, OzMenuRowsSizePreset, OzScreenSizeAwarePopoverModal }
}

})